

/**
 * The adminConsoleRouter returns the mapping of admin console tabs to components
 */

import AdminOverviewTab from "./tabs/admin_overview/AdminOverviewTab"
import CastingMeetingTab from "./tabs/casting_meeting/CastingMeetingTab"
import { Archive, DataObject, ReceiptLong, SmartToy, TheaterComedy, Tune } from "@mui/icons-material"
import ManageShowsTab from "./tabs/manage_shows/ManageShowsTab"
import { LicenceTab } from "./tabs/licence/LicenceTab"
import DataAndAccountsTab from "./tabs/data_and_accounts/DataAndAccountsTab"
import ArchiveTab from "./tabs/archive/ArchiveTab"

let adminConsoleRouter = {

  overview: 
  {
    title: 'Admin Overview',
    icon: <Tune />,
    element: <AdminOverviewTab />
  },

  clashbot: 
  {
    title: 'ClashBot',
    icon: <SmartToy />,
    element: <CastingMeetingTab />,
    separatorAfter: true
  },

  shows:
  {
    title: 'Manage Seasons',
    icon: <TheaterComedy />,
    element: <ManageShowsTab />
  },

  data:
  {
    title: 'Your Data',
    icon: <DataObject />,
    element: <DataAndAccountsTab />,
    separatorAfter: true
  },

  archive:
  {
    title: 'Archive',
    icon: <Archive />,
    element: <ArchiveTab />,
  },

  licence:
  {
    title: 'Licence',
    icon: <ReceiptLong />,
    element: <LicenceTab />
  }

}


export default adminConsoleRouter